<template>
    <div id="visits-calendar">

        <div class="d-flex flex-column  my-5" v-if="visits.length > 0">
            <h3 class="text-center pt-5">Vizitele în Academia Spațială Dr.Leahu</h3>
            <div class="row w-100 py-5 visits">
                <div class="col-6 col-sm-4 col-md-3 col-lg-2 mb-3 mb-lg-4 text-center" v-for="(visit, index) in visits"
                     v-bind:key="index">
                    <div class="d-flex flex-column mx-auto visit-day">
                        <div class="mx-auto my-auto text-center">
                            <h6 v-text="getDayVisit(visit.logout_at)"></h6>
                            <h6 v-text="getMonthVisit(visit.logout_at)"></h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="text-center my-5">
            <h5 class="pt-5">Nu ai nicio vizită la medic.</h5>
        </div>
    </div>
</template>

<script>

    const axios = require('axios');

    export default {
        name: "VisitsCalendar",
        data() {
            return {
                baseUrl: null,
                terminalUID: null,
                accessToken: null,
                visits: [],
                months: [
                    'Ian',
                    'Feb',
                    'Mar',
                    'Apr',
                    'Mai',
                    'Iun',
                    'Iul',
                    'Aug',
                    'Sep',
                    'Oct',
                    'Noi',
                    'Dec'
                ]
            }
        },
        mounted() {
            let self = this;
            this.baseUrl = this.$cookie.get('base-url');
            this.accessToken = this.$cookie.get('access-token');
            this.terminalUID = this.$cookie.get('terminal-uid');
            this.headers = {
                'terminal-uid': this.terminalUID,
                'Access-Control-Allow-Headers': 'Authorization',
                'Authorization': this.accessToken,
                'Content-Type': 'application/json',
            };
            setTimeout(function () {
                self.getVisits();
            }, 300)
        },
        methods: {
            getVisits() {
                let self = this;
                const headers = this.headers;
                axios.defaults.headers.common['Authorization'] = this.accessToken;
                axios.defaults.headers.common['terminal-uid'] = this.terminalUID;

                axios.get(
                    this.baseUrl + 'api/profile/doctorVisits',
                    {
                        headers
                    })
                    .then(function (response) {
                        // console.log('visits response', response);
                        self.visits = response.data.result.doctor_logins;

                        if (response.status !== 200) {
                            console.log('response status', response.status);
                            throw new Error(response.status)
                        }

                    })
                    .catch(function (error) {
                        if (error.response) {
                            console.error('Status:', error.response.status);
                            //     if (error.response.status === 401 || error.response.status === 400) {
                            //         self.$store.commit('setUser', null);
                            //         self.$cookie.delete('access-token');
                            //         self.$cookie.delete('user-token');
                            //         self.$cookie.delete('terminal_id');
                            //         self.$cookie.delete('user_type_id');
                            //         self.$cookie.delete('terminal-uid');
                            //         // self.$forceUpdate();
                            //         location.reload();
                            //     }
                        } else {
                            console.error('Error Message:', error.message);
                        }
                    });

            },
            getDayVisit(visitDay) {
                return new Date(visitDay).getDate();
            },
            getMonthVisit(visitDay) {
                return this.months[new Date(visitDay).getMonth()];
            }
        }
    }
</script>

<style scoped>

</style>